// extracted by mini-css-extract-plugin
export default {"box":"refundListPage_box__X21im"};